module.exports = __webpack_public_path__ + "static/img/i13.bde97d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/eng/i13.png
// module id = 988n
// module chunks = 0